__turbopack_context__.v({
  "active": "SetBrowsingLevelModal-module-scss-module__T1kspq__active",
  "content": "SetBrowsingLevelModal-module-scss-module__T1kspq__content",
  "horizontal": "SetBrowsingLevelModal-module-scss-module__T1kspq__horizontal",
  "noReasonButton": "SetBrowsingLevelModal-module-scss-module__T1kspq__noReasonButton",
  "root": "SetBrowsingLevelModal-module-scss-module__T1kspq__root",
});
